import * as React from 'react';

import { Col, Row } from 'antd';

import { Fade } from 'react-awesome-reveal';

interface AnimatedHeaderProps {
    header: React.ReactNode;
    subheader?: React.ReactNode;
    style?: React.CSSProperties;
    fadeDirection?: 'bottom-left' | 'bottom-right' | 'down' | 'left' | 'right' | 'top-left' | 'top-right' | 'up';
    damping?: number;
}

export const AnimatedHeader: React.FC<AnimatedHeaderProps> = (props) => {

    return (
        <Fade
            triggerOnce={true}
            cascade={true}
            damping={props.damping}
            direction={props.fadeDirection}
        >
            <Row
                align="middle"
                justify="center"
                style={{
                    ...props.style,
                }}
            >
                <Col
                    style={{
                        fontWeight: 'normal',
                        fontSize: '25px',
                        textAlign: 'center',
                    }}
                >
                    {props.header}
                </Col>
            </Row>

            {!!props.subheader &&
                <Row
                    align="middle"
                    justify="center"
                >
                    <Col
                        style={{
                            fontWeight: 'lighter',
                            fontSize: '20px',
                            textAlign: 'center',
                        }}
                    >
                        {props.subheader}
                    </Col>
                </Row>
            }
        </Fade>

    );
};